module.exports = __webpack_public_path__ + "img/company_5.a2b30681.png";